import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=c52e445c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52e445c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c52e445c')) {
      api.createRecord('c52e445c', component.options)
    } else {
      api.reload('c52e445c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=c52e445c&scoped=true&", function () {
      api.rerender('c52e445c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25xx73rc6ZHze/JS/comp/Accordion.vue"
export default component.exports